<template>
  <div v-if="!account" class="kanban-card--photo">
    <span class="avatar-title rounded-circle bg-soft-secondary text-secondary ">
      <i class="iconoir-user font-size-22 text-muted" v-b-tooltip.hover :title="way == 'reporter' ? $t('task.system-reporter') : $t('task.not-assigned')" />
    </span>
  </div>
  <div v-else class="float-left" :class="`avatar-${avatarSize}`" v-b-tooltip.hover :title="account.name">
    <span v-if="!account.avatar" class="avatar-title rounded-circle bg-soft-success text-success font-size-14">
      {{ userLetterAvatar }}
    </span>
    <img v-else :src="account.avatar" style="border:1px solid #dbdbdb" class="avatar-title rounded-circle bg-white" />
  </div>
</template>

<script>
export default {
  props: ["account", "size", "way"],
  computed: {
    avatarSize() {
      return this.size ?? "xxs";
    },
    userLetterAvatar() {
      const arr = this.account?.name?.split(" ");
      if (!arr) {
        return "X";
      }
      const avatar = [];
      for (const [i, value] of arr.entries()) {
        avatar.push(value.charAt(0));
        if (i == 1) {
          break;
        }
      }
      return avatar.join("");
    },
  },
};
</script>
